import { render, staticRenderFns } from "./product_group_edit.vue?vue&type=template&id=0153928f&scoped=true"
import script from "./product_group_edit.vue?vue&type=script&lang=js"
export * from "./product_group_edit.vue?vue&type=script&lang=js"
import style0 from "./product_group_edit.vue?vue&type=style&index=0&id=0153928f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153928f",
  null
  
)

export default component.exports